module.exports = __webpack_public_path__ + "img/ffBanner_PC.74533f79.png";